import { render, staticRenderFns } from "./ApolloExample.vue?vue&type=template&id=6c95b848&scoped=true&"
import script from "./ApolloExample.vue?vue&type=script&lang=js&"
export * from "./ApolloExample.vue?vue&type=script&lang=js&"
import style0 from "./ApolloExample.vue?vue&type=style&index=0&id=6c95b848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c95b848",
  null
  
)

export default component.exports